import { call, put, takeLatest } from "redux-saga/effects";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import {
  defaultReturn
  , multipleObjectReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
} from "shared-utility/store/utils/helpers";

// ACTIONS

// TODO: Wire this up!!!
export const DEAL_SHARING_SEARCH_USER_EMAIL = generateDefaultActions("DEAL_SHARING_SEARCH_USER_EMAIL");
export const searchUserEmail = payload => makePayload(DEAL_SHARING_SEARCH_USER_EMAIL.value, payload);
function* searchUserEmailSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;
  const url = `/sharing/searchEmail/${payload.inputEmail}`;
  yield requestSaga(DEAL_SHARING_SEARCH_USER_EMAIL, url, "GET");
  if (callback) {
    callback();
  }
}

// REDUCER

const initialState = {
  searchResult: {}
};

export function dealSharingReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case DEAL_SHARING_SEARCH_USER_EMAIL.success:
      return defaultReturn(state, payload.result, "searchResult");
    case DEAL_SHARING_SEARCH_USER_EMAIL.failure:
      return defaultReturn(state, null, "searchResult");

      // DEFAULT
    default:
      return state;
  }
}

// SAGA

export function* dealSharingSaga() {
  yield takeLatest(DEAL_SHARING_SEARCH_USER_EMAIL.value, searchUserEmailSaga);
}
